<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Fuels",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Driver Fuels",
            items: [
               {
                  text: "Drivers",
                  href: "/drivers",
               },  
               {
                  text: "Fuels",
                  active: true,
               },                   
            ],

            fsfuels: [],    

            fsfuel: {
               id: null,
               fuel_id : "",
               fuel_station_id: "",
               capacity: "",
               stock: "",

            },
            fueltypes:[],
            truck_details: [],   
            
            pagination: {},
            
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      created() {
         this.fetchFuels();
      },
      mounted() {
      },

      methods: {
         setStock(truck_fuels) {
            this.updatestock.id = truck_fuels.id;
            //alert(truck_fuels.id);

            this.showModal('stock-modal');

         },
         fetchFuelTypes() {  

               let url = "fuelstation/fuel_station/getFuelstationPendingFuels?truck_id=" + this.$route.params.id;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.fueltypes = responseData.fuels;
                     this.fuel_visible = true;
                  })
                  .catch((err) => console.log(err));
                  
               },
         fetchFuels() {
            let url = "fuelstation/fuel_station/truck/fuels?truck_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               if(res.status == 200) {
               var responseData = res.data.data;
               console.log(responseData);
               this.fsfuels = responseData.truck_fuels;
               //this.truck_details = responseData.truck_details;
               this.fetchFuelTypes();

               }  
            })
            .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
         getToken() {
         if (localStorage.getItem('sigofuel_fuelstation')) {
            var sigofuel_fuelstation =  JSON.parse(localStorage.getItem('sigofuel_fuelstation'));
            if(sigofuel_fuelstation.token) {
               this.token = sigofuel_fuelstation.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }},
         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end me-2"><i class='bx bx-chevrons-left'></i> Back</a>

                     </div>
                  </div>
                
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Fuel</th>
                              <th>Capacity</th>
                              <th>Stock (in litres)</th>
                              <th>Created on</th>
                              <th>Last Updated On</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(fsfuels.length)">
                           <tr v-for="(fuel) in fsfuels" :key="fuel.id">
                              <td>{{fuel.fuel_en}}
                                 <p>{{fuel.fuel_so}}</p></td>
                              <td>{{fuel.capacity}}</td>
                              <td>{{fuel.stock}}</td>
                              <td>{{fuel.created_at | formatDateTime}}</td>
                              <td>{{fuel.updated_at | formatDateTime}}</td>
                           </tr>

                 
                        </tbody>
                        <tbody v-else>  <tr>
                              <td colspan="6" class="text-center">No Fuels found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->          

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
